module.exports = __webpack_public_path__ + "static/media/HeaderOfficeIcon.b52730b8.svg";